import { render, staticRenderFns } from "./corporate-card.html?vue&type=template&id=e742ca52&scoped=true&"
import script from "./corporate-card.js?vue&type=script&lang=js&"
export * from "./corporate-card.js?vue&type=script&lang=js&"
import style0 from "./corporate-card.scss?vue&type=style&index=0&id=e742ca52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e742ca52",
  null
  
)

export default component.exports